import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation AbsenceReasons($id: Int) {
  deleteAbsenceReason(id: $id) {
    id
    message
    teams {
      id
      name
    }
  }
}`;

function deleteAbsenceReason({ id }) {
  return apollo.client.mutate({
    mutation,
    variables: { id: parseInt(id, 10) },
  }).then((data) => data.data.deleteAbsenceReason);
}

export default deleteAbsenceReason;
